import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogComponent, DialogConfigInterface} from '../../../../shared/components/dialog';

import {EditTradingAccountForm} from '../../forms';

@Component({
    selector: 'app-trading-account-edit-account',
    templateUrl: './trading-account-edit-account.component.html',
    styleUrls: ['./trading-account-edit-account.component.scss']
})
export class TradingAccountEditAccountComponent extends DialogComponent<TradingAccountEditAccountComponent> implements OnInit {
    public editAccountForm: EditTradingAccountForm;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface
        },
        public dialogRef: MatDialogRef<TradingAccountEditAccountComponent>
    ) {
        super(dialogRef);
    }

    ngOnInit() {
        this.editAccountForm = new EditTradingAccountForm();
        this.editAccountForm.initForm();
    }
}
